<template>
  <div
    class="app-logo-badge"
    :class="[
      `app-logo-badge--${resolvedVariant}`,
      hasLogo ? 'app-logo-badge--has-logo' : 'app-logo-badge--no-logo',
    ]"
  >
    <AppImageLoader
      v-if="hasLogo"
      :src="src"
      :alt="alt"
      fit="contain"
      class="app-logo-badge__media"
    />

    <div v-else class="app-logo-badge__fallback">
      <slot name="fallback">{{ initials }}</slot>
    </div>

    <button
      v-if="showRemove && hasLogo"
      type="button"
      class="app-logo-badge__remove"
      :aria-label="removeAriaLabel"
      :title="removeTitle || removeAriaLabel"
      @click="$emit('remove')"
    >
      <i class="fa fa-trash" aria-hidden="true"></i>
    </button>
  </div>
</template>

<script>
import AppImageLoader from '@/components/common/AppImageLoader.vue';

export default {
  name: 'AppLogoBadge',
  components: { AppImageLoader },
  emits: ['remove'],
  props: {
    src: {
      type: String,
      default: '',
    },
    alt: {
      type: String,
      default: '',
    },
    initials: {
      type: String,
      default: '',
    },
    variant: {
      type: String,
      default: 'detail',
      validator(value) {
        const normalized = String(value || '').trim().toLowerCase();
        return normalized === 'detail' || normalized === 'modal';
      },
    },
    showRemove: {
      type: Boolean,
      default: false,
    },
    removeAriaLabel: {
      type: String,
      default: 'Quitar logo',
    },
    removeTitle: {
      type: String,
      default: '',
    },
  },
  computed: {
    hasLogo() {
      return String(this.src || '').trim() !== '';
    },
    resolvedVariant() {
      const normalized = String(this.variant || 'detail').trim().toLowerCase();
      return normalized === 'modal' ? 'modal' : 'detail';
    },
  },
};
</script>

<style scoped>
.app-logo-badge {
  position: relative;
  overflow: hidden;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.app-logo-badge--detail {
  color: #0062a3;
  font-size: 15px;
  font-weight: 700;
}

.app-logo-badge--detail.app-logo-badge--has-logo {
  width: 130px;
  min-width: 130px;
  height: 100px;
  border-radius: 12px;
  background: linear-gradient(180deg, #f8fbff 0%, #f1f6fb 100%);
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.7);
}

.app-logo-badge--detail.app-logo-badge--no-logo {
  width: 53px;
  height: 53px;
  border-radius: 9px;
  background: linear-gradient(135deg, rgba(0, 112, 205, 0.18), rgba(0, 178, 226, 0.28));
  border: 1px solid rgba(0, 112, 205, 0.24);
}

.app-logo-badge--modal {
  width: 130px;
  min-width: 130px;
  height: 100px;
  border-radius: 12px;
  background: linear-gradient(180deg, #f8fbff 0%, #f1f6fb 100%);
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.7);
}

.app-logo-badge__media {
  width: 100%;
  height: 100%;
  border-radius: inherit;
}

.app-logo-badge--detail .app-logo-badge__media,
.app-logo-badge--modal .app-logo-badge__media {
  border-radius: 8px;
}

.app-logo-badge__fallback {
  width: 100%;
  height: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
}

.app-logo-badge__remove {
  position: absolute;
  right: 8px;
  bottom: 8px;
  width: 28px;
  height: 28px;
  border: 1px solid #cbd5e1;
  border-radius: 999px;
  background: rgba(248, 250, 252, 0.95);
  color: #e11d48;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 10px rgba(15, 23, 42, 0.15);
}

.app-logo-badge__remove:hover {
  color: #be123c;
  background: #ffffff;
}

@media (max-width: 860px) {
  .app-logo-badge--modal {
    width: 100%;
    max-width: 230px;
    height: 130px;
  }
}
</style>
